import React from 'react';
import { ProgressBar } from 'react-bootstrap';

class ProgressBarRecibo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
        this.dialogRef = React.createRef();
    }

    componentDidMount() {
        // Manejar el estado inicial del modal
        if (this.props.isOpen) {
            this.abrirModal();
        }
    }

    componentDidUpdate(prevProps) {
        // Detectar cambios en isOpen para abrir/cerrar el modal
        if (this.props.isOpen !== prevProps.isOpen) {
            if (this.props.isOpen) {
                this.abrirModal();
            } else {
                this.cerrarModalConAnimacion();
            }
        }
    }

    abrirModal = () => {
        if (this.dialogRef.current && !this.dialogRef.current.open) {
            this.dialogRef.current.showModal();
        }
    }

    cerrarModal = () => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
            this.dialogRef.current.close();
        }
    }

    cerrarModalConAnimacion = () => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
            this.dialogRef.current.style.scale = '0';
            setTimeout(() => {
                if (this.dialogRef.current && this.dialogRef.current.open) {
                    this.dialogRef.current.close();
                }
            }, 300);
        }
    }

    manejarCancelar = () => {
        this.cerrarModalConAnimacion();
        setTimeout(() => {
            this.props.onClose?.();
        }, 300);
    }

    render() {
        const { isOpen, cantidadProcesada = 0, cantidadTotal = 0 } = this.props;


        if (!isOpen) return null;

        const porcentaje = cantidadTotal > 0 ? parseInt((cantidadProcesada / cantidadTotal) * 100) : 0;

        return (
            <div className="component-modal">
                <dialog
                    className="modal"
                    id="modal-progress"
                    ref={this.dialogRef}
                    onClose={this.manejarCancelar}
                >
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="row justify-content-center p-3">
                                <div>
<div className="progress-container" style={{ height: "15px", background: "#e0e0e0", borderRadius: "5px", overflow: "hidden" }}>
  <div
    className="progress-bar"
    style={{
      width: `${porcentaje}%`,
      height: "100%",
      backgroundColor: "#2563eb",
      transition: "width 0.3s ease"
    }}
  ></div>
</div>
<p style={{ textAlign: "center", marginTop: "5px" }}>{porcentaje}% — {cantidadProcesada} de {cantidadTotal}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </dialog>
            </div>
        );
    }
}

export default ProgressBarRecibo;